module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle1",
    attrs: {
      "id": "fm2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Contents#rfm2"
    }
  }, [_c('b', [_vm._v("Notes on the Text")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("I have tried to minimize abbreviations in this narration, but several recur:")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_c('span', [_vm._v("AJDC – the American Joint Distribution Committee, also known as Joint. This is a Jewish relief organization based in New York and still very much in existence. It provided crucial assistance to Jews in Europe, especially immediately after the Holocaust. My mother was employed by the AJDC for the latter part of her time at Bergen-Belsen.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_c('span', [_vm._v("NIOD – the acronym for the Netherlands Institute for War, Holocaust and Genocide Studies. This organization has changed its name several times, but NIOD always refers to it.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_c('span', [_vm._v("UNRRA – United Nations Relief and Rehabilitation Administration, an organization that my parents, especially my father, were involved with for a couple of years after the war.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_c('span', [_vm._v("Because this story covers almost 100 years, it jumps around in time a bit. Many conversations with Jo Jacobsthal (my uncle), Joe Wolhandler (who was present in 1945, postwar, at Bergen-Belsen) and even with my mother took place in the mid-1990s and early 2000s, but are often retold in the present tense. I have tried to be clear about these distinctions in narrative time.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0ca20a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Notes_on_the_Text.vue
// module id = 72
// module chunks = 0